import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, updatedata,formatdate, getdate, deletedata } from "../../util/global";
import MessageTable from './MessageTable';
import WhatsappForm from './WhatsappForm';
import SendMessageForm from './SendMessageForm';



const Message = () => {
 
  const [messagedata, setmessagedata] = useState([]);
  const [showmodal, setshowmodal] = useState(false);

  const fetchdata = async () => {
    try {
      let mdata = await getdata({filter:{datatype:"sendmessagedata"}});
      setmessagedata(mdata.reverse());
    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchdata(); }, []);


  return (
    <div className="content-area">

      <MessageTable 
        messagedata={messagedata}
        />
    
    </div>
  );
};

export default Message;